import { useEffect, useRef, useState } from "react"
import { Button, Row } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import Swal from "sweetalert2"

const Asr = () => {
  const navigate = useNavigate()

  const mediaRecorderRef = useRef(null)
  const audioChunksRef = useRef([])
  const [recording, setRecording] = useState(false)

  const startRecording = async () => {
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      alert('Votre navigateur ne supporte pas la capture audio')
      return
    }
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
      mediaRecorderRef.current = new MediaRecorder(stream)
      audioChunksRef.current = []

      mediaRecorderRef.current.ondataavailable = (e) => {
        if (e.data.size > 0) audioChunksRef.current.push(e.data)
      }

      mediaRecorderRef.current.onstop = async () => {
        const audioBlob = new Blob(audioChunksRef.current, { type: 'audio/wav' })
        await sendAudio(audioBlob)
      }

      mediaRecorderRef.current.start()
      setRecording(true)
    } catch (err) {
      console.error(err)
      alert('Erreur lors de l\'accès au microphone')
    }
  }

  const stopRecording = () => {
    if (mediaRecorderRef.current && mediaRecorderRef.current.state !== 'inactive') {
      mediaRecorderRef.current.stop()
      setRecording(false)
    }
  }

  const sendAudio = async (blob) => {
    try {
      const formData = new FormData()
      formData.append('command', blob, 'recording.wav')

      const response = await fetch('https://vocal-doc.rhyzom.dev/api/asr', {
        method: 'POST',
        body: formData,
      })

      if (!response.ok) {
        window.speechSynthesis.cancel()
        const synth = window.speechSynthesis
        const utterance = new SpeechSynthesisUtterance('Erreur lors de la transcription')
        utterance.lang = 'fr-FR'
        synth.speak(utterance)

        Swal.fire({
          icon: 'error',
          title: 'Erreur lors de la transcription'
        }).then(() => navigate('/'))
        return
      }
      const data = await response.json()
      console.log('Transcription reçue:', data.command)
      alert('Transcription : ' + data.command)
    } catch (err) {
      console.error(err)
      window.speechSynthesis.cancel()
      const synth = window.speechSynthesis
      const utterance = new SpeechSynthesisUtterance('Problème de connexion au serveur')
      utterance.lang = 'fr-FR'
      synth.speak(utterance)

      Swal.fire({
        icon: 'error',
        title: 'Problème de connexion au serveur'
      }).then(() => navigate('/'))
    }
  }


  useEffect(() => {
    window.speechSynthesis.cancel()
    const synth = window.speechSynthesis
    const utterance = new SpeechSynthesisUtterance('Veuillez maintenir le bouton bleu pour enregisrer et relâchez lorsque vous avez terminé')
    utterance.lang = 'fr-FR'
    synth.speak(utterance)
  }, [])

  return (
    <div className="d-flex flex-column" style={{ position: 'absolute', width: '100vw', height: '100vh', overflow: 'hidden' }}>
      <Button className="m-3 py-5 btn-primary"
          onMouseDown={startRecording}
          onTouchStart={startRecording}
          onMouseUp={stopRecording}
          onTouchEnd={stopRecording}
      >
        {recording ? 'Enregistrement...' : 'Appuyez pour enregistrer'}
      </Button>
      <Button className="m-3 py-5 btn-warning" onClick={() => navigate('/')}>
        Retour
      </Button>
    </div>
  )
}

export default Asr
